import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-ports-popup',
  templateUrl: './ports-popup.component.html',
  styleUrls: ['./ports-popup.component.scss']
})
export class PortsPopupComponent implements OnInit {
 list: any;
  receivedData: any;
  formData = {
    port_name: '',
    latitude: 0,
    longitude: 0,
  };
  constructor(
      public dialogRef: MatDialogRef<PortsPopupComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private requestFormService: RequestFormService,
    ) {

    }

  ngOnInit() {
    if (this.data && this.data.port_name) {
      this.formData.port_name = this.data.port_name;
    }
  }
  onSubmit(confirmed: boolean) {
    const payload = {
      port_name : this.formData.port_name,
      latitude:this.formData.latitude,
      longitude:this.formData.longitude
    }
    if (confirmed) {
      if (this.data && this.data.disableApiCall) {
        this.dialogRef.close({ event: 'success', data: payload });
      } else {
        this.requestFormService.updatePortData(payload).subscribe(data =>{
          this.dialogRef.close('success');
        });
      }
    }else{
      this.dialogRef.close();
    }
  }
  toNumber(value: string | number): number {
    return typeof value === 'number' ? value : parseFloat(value) || 0;
  }
  
}
